import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const HomePage = () => {
  const services = [
    {
      title: 'Concrete & Patios',
      image: 'https://public.readdy.ai/ai/img_res/0ca32d51da6f976aa968a0de0d217550.jpg',
      items: [
        'Stamped & Decorative Concrete',
        'Concrete Slabs & Foundations',
        'Patio Installations',
        'Walkways & Driveways',
      ],
    },
    {
      title: 'Outdoor Structures',
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20screened-in%20porch%20with%20dark%20charcoal%20frames%20and%20white%20screens%20in%20a%20Dallas%20Fort%20Worth%20home%2C%20warm%20interior%20lighting%20visible%20through%20screens%2C%20simple%20clean%20outdoor%20setting%20with%20minimal%20background%20distractions%2C%20professional%20construction%20photography&width=600&height=700&seq=screened-porch-vantex-2&orientation=portrait',
      items: [
        'Screened-In Porches',
        'Patio Enclosures',
        'Pergolas & Covers',
        'Custom Outdoor Living',
      ],
    },
    {
      title: 'Fences & Gates',
      image: 'https://readdy.ai/api/search-image?query=Modern%20horizontal%20wood%20fence%20installation%20with%20dark%20stained%20cedar%20planks%20and%20steel%20posts%20in%20a%20Dallas%20Texas%20residential%20property%2C%20clean%20simple%20background%20showing%20professional%20craftsmanship%20and%20straight%20lines%2C%20high%20quality%20construction%20detail%20photography&width=600&height=700&seq=wood-fence-vantex-3&orientation=portrait',
      items: [
        'Wood Fences & Privacy Screens',
        'Custom Gates & Entries',
        'Fence Repairs & Replacement',
        'Decorative Fencing',
      ],
    },
  ];

  const projects = [
    {
      title: 'Stamped Concrete Patio',
      location: 'Plano, TX',
      description: 'Custom stamped concrete with integrated seating',
      image: 'https://readdy.ai/api/search-image?query=Completed%20stamped%20concrete%20patio%20project%20with%20decorative%20patterns%20in%20warm%20brown%20tones%2C%20outdoor%20furniture%20visible%2C%20Dallas%20Texas%20residential%20backyard%2C%20simple%20clean%20background%2C%20professional%20construction%20photography%20showing%20finished%20quality%20work&width=800&height=600&seq=project-concrete-vantex-4&orientation=landscape',
    },
    {
      title: 'Screened Porch Addition',
      location: 'Frisco, TX',
      description: 'Full porch enclosure with custom lighting',
      image: 'https://readdy.ai/api/search-image?query=Finished%20screened-in%20porch%20interior%20with%20comfortable%20seating%20and%20warm%20lighting%2C%20dark%20frames%20with%20white%20screens%2C%20Fort%20Worth%20Texas%20home%2C%20simple%20clean%20setting%2C%20professional%20construction%20photography%20showing%20completed%20craftsmanship&width=800&height=600&seq=project-porch-vantex-5&orientation=landscape',
    },
    {
      title: 'Custom Wood Fence',
      location: 'McKinney, TX',
      description: 'Horizontal cedar fence with matching gate',
      image: 'https://readdy.ai/api/search-image?query=Completed%20horizontal%20wood%20fence%20installation%20with%20dark%20stain%20and%20modern%20design%20in%20Dallas%20Texas%20residential%20yard%2C%20simple%20clean%20background%2C%20professional%20construction%20photography%20showing%20straight%20lines%20and%20quality%20craftsmanship&width=800&height=600&seq=project-fence-vantex-6&orientation=landscape',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-screen flex items-center">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Beautiful%20completed%20outdoor%20patio%20construction%20project%20at%20dusk%20with%20warm%20ambient%20lighting%2C%20stamped%20concrete%20surface%2C%20modern%20outdoor%20furniture%2C%20Dallas%20Fort%20Worth%20Texas%20residential%20setting%2C%20professional%20construction%20photography%20with%20rich%20warm%20tones%20and%20inviting%20atmosphere%2C%20simple%20clean%20background&width=1920&height=1080&seq=hero-vantex-main-7&orientation=landscape"
            alt="Vantex Construction Projects"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
        </div>

        <div className="relative max-w-[1400px] mx-auto px-6 lg:px-12 w-full">
          <div className="max-w-3xl">
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-5xl md:text-6xl lg:text-7xl font-black text-white leading-tight mb-6"
            >
              PROFESSIONAL CONSTRUCTION<br />YOU CAN TRUST
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="text-xl text-neutral-lighter-gray mb-10"
            >
              Licensed & Insured Residential Contractor Serving Dallas-Fort Worth
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="flex flex-wrap gap-4 mb-12"
            >
              <Link
                to="/quote"
                className="bg-primary-red hover:bg-primary-red-dark text-white px-8 py-4 font-bold text-base tracking-wide transition-colors inline-flex items-center whitespace-nowrap cursor-pointer"
              >
                REQUEST FREE ESTIMATE
                <i className="ri-arrow-right-line ml-2 text-xl w-5 h-5 flex items-center justify-center"></i>
              </Link>
              <Link
                to="/projects"
                className="border-2 border-white hover:bg-white hover:text-neutral-black text-white px-8 py-4 font-bold text-base tracking-wide transition-all inline-flex items-center whitespace-nowrap cursor-pointer"
              >
                VIEW OUR WORK
              </Link>
            </motion.div>

            {/* Trust Badges */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              className="flex flex-wrap gap-4"
            >
              <div className="bg-neutral-charcoal/80 border border-primary-red px-4 py-2 text-white text-sm font-semibold whitespace-nowrap">
                LICENSED & INSURED
              </div>
              <div className="bg-neutral-charcoal/80 border border-primary-red px-4 py-2 text-white text-sm font-semibold whitespace-nowrap">
                WARRANTY ON ALL PROJECTS
              </div>
              <div className="bg-neutral-charcoal/80 border border-primary-red px-4 py-2 text-white text-sm font-semibold whitespace-nowrap">
                LOCAL DFW CONTRACTOR
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Services Grid Section */}
      <section className="bg-neutral-black py-20 lg:py-28">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-black text-white mb-4">
              WHAT WE BUILD
            </h2>
            <p className="text-lg text-neutral-light-gray max-w-3xl mx-auto">
              Outdoor structures, concrete work, and interior remodeling for North Texas homeowners
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <motion.div
                key={service.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-neutral-charcoal rounded-lg overflow-hidden hover:transform hover:scale-105 transition-transform duration-300 cursor-pointer"
              >
                <div className="relative h-80">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
                  <h3 className="absolute bottom-6 left-6 text-2xl font-bold text-white">
                    {service.title}
                  </h3>
                </div>
                <div className="p-6">
                  <ul className="space-y-3 mb-6">
                    {service.items.map((item) => (
                      <li key={item} className="flex items-start text-white">
                        <i className="ri-checkbox-circle-fill text-primary-red mr-3 mt-1 text-lg w-5 h-5 flex items-center justify-center"></i>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                  <Link
                    to="/services"
                    className="text-primary-red hover:text-primary-red-dark font-bold inline-flex items-center transition-colors whitespace-nowrap cursor-pointer"
                  >
                    LEARN MORE
                    <i className="ri-arrow-right-line ml-2 w-5 h-5 flex items-center justify-center"></i>
                  </Link>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Trust & Process Section */}
      <section className="bg-white py-20 lg:py-28">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
            <div className="lg:col-span-2">
              <p className="text-primary-red text-sm font-bold tracking-widest mb-4">
                WHY CHOOSE VANTEX
              </p>
              <h2 className="text-4xl md:text-5xl font-black text-neutral-charcoal mb-6">
                BUILT ON TRUST & <span className="font-serif italic">CRAFTSMANSHIP</span>
              </h2>
              <p className="text-neutral-gray text-lg leading-relaxed">
                We're a local Dallas-Fort Worth contractor committed to delivering quality construction work with transparent pricing and reliable service. Every project is backed by proper licensing, insurance, and a 5-year workmanship warranty.
              </p>
            </div>

            <div className="lg:col-span-3 space-y-6">
              <motion.div
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                className="bg-primary-red p-8 rounded-lg relative"
              >
                <div className="flex justify-between items-start">
                  <div>
                    <p className="text-6xl font-serif font-bold text-white mb-2">100%</p>
                    <h3 className="text-2xl font-bold text-white mb-3">LICENSED & INSURED</h3>
                    <p className="text-white/90 text-base">
                      Every project backed by proper licensing and comprehensive insurance coverage
                    </p>
                  </div>
                  <div className="w-12 h-12 rounded-full border-2 border-white flex items-center justify-center cursor-pointer hover:bg-white hover:text-primary-red transition-colors">
                    <i className="ri-arrow-right-up-line text-2xl"></i>
                  </div>
                </div>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="bg-neutral-dark-gray p-8 rounded-lg relative"
              >
                <div className="flex justify-between items-start">
                  <div>
                    <p className="text-6xl font-serif font-bold text-white mb-2">WARRANTY</p>
                    <h3 className="text-2xl font-bold text-white mb-3">ON ALL PROJECTS</h3>
                    <p className="text-white/90 text-base">
                      We stand behind our work with comprehensive warranties on all construction projects
                    </p>
                  </div>
                  <div className="w-12 h-12 rounded-full border-2 border-white flex items-center justify-center cursor-pointer hover:bg-white hover:text-neutral-dark-gray transition-colors">
                    <i className="ri-arrow-right-up-line text-2xl"></i>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* Project Showcase Section */}
      <section className="bg-neutral-bg-gray py-20 lg:py-28">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-black text-neutral-charcoal mb-4 inline-flex items-center justify-center">
              RECENT PROJECTS
              <i className="ri-hammer-fill text-primary-red ml-4 text-4xl w-10 h-10 flex items-center justify-center"></i>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {projects.map((project, index) => (
              <motion.div
                key={project.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="relative rounded-2xl overflow-hidden group cursor-pointer h-96"
              >
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                  <h3 className="text-2xl font-bold mb-2">{project.title}</h3>
                  <p className="text-neutral-lighter-gray mb-2">{project.location}</p>
                  <p className="text-white/90">{project.description}</p>
                </div>
              </motion.div>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link
              to="/projects"
              className="inline-flex items-center bg-neutral-charcoal hover:bg-neutral-black text-white px-8 py-4 font-bold text-base tracking-wide transition-colors whitespace-nowrap cursor-pointer"
            >
              VIEW ALL PROJECTS
              <i className="ri-arrow-right-line ml-2 text-xl w-5 h-5 flex items-center justify-center"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-white py-20 lg:py-28">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 text-center">
          <h2 className="text-4xl md:text-5xl font-black text-neutral-charcoal mb-6">
            READY TO START YOUR PROJECT?
          </h2>
          <p className="text-xl text-neutral-gray mb-10 max-w-2xl mx-auto">
            Get a detailed, transparent estimate from a licensed DFW contractor
          </p>
          <Link
            to="/quote"
            className="inline-flex items-center bg-primary-red hover:bg-primary-red-dark text-white px-10 py-5 font-bold text-lg tracking-wide transition-colors whitespace-nowrap cursor-pointer"
          >
            REQUEST FREE ESTIMATE
            <i className="ri-arrow-right-line ml-3 text-2xl w-6 h-6 flex items-center justify-center"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HomePage;